module.exports = __webpack_public_path__ + "img/blood-not-allowed.d3d4a8c6.png";